import Vue from 'vue'
import Router from 'vue-router'
import oidcJS from '../public/oidcRoot'
import commonJs from "../public/common";
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: "*",
      redirect: "/notFound"
    },
    {
      path: '/',
      name: 'main',
      redirect:'/home',
      component: resolve => require(['@/components/authLogin/main'],resolve),

      children:[
        {
          path: '/home',        //首页
          name: 'home',
          component: resolve => require(['@/components/home/homePage'],resolve),
          meta:{
            hoverCode:'home'
          }
        },
        {
          path: '/register',
          name: 'register',             //主账户注册
          component: resolve => require(['@/components/authLogin/register'],resolve),
        },

        {
          path: '/forgetPsd',
          name:'forgetPsd',
          component: resolve => require(['@/components/authLogin/forgetPsd'],resolve),
        },
        {
          path: '/againEmail',
          name: 'againEmail',             //再次验证邮箱
          component: resolve => require(['@/components/authLogin/againEmail'],resolve),
        },
        {
          path: '/activationSuccessful',
          name: 'activationSuccessful',             //激活成功
          component: resolve => require(['@/components/authLogin/activationSuccessful'],resolve),
        },
        {
          path: '/activationEmail',
          name: 'activationEmail',             //激活邮件
          component: resolve => require(['@/components/authLogin/activationEmail'],resolve),
        },
        {
          path: '/companyInformation',
          name: 'companyInformation',             //请认证企业信息
          component: resolve => require(['@/components/manager/companyInformation'],resolve),
          meta:{
            hoverCode:'applicationList',
            isLogin:true
          }
        },
        {
          path: '/applicationList',
          name: 'applicationList',             //应用列表
          component: resolve => require(['@/components/manager/applicationList'],resolve),
          meta:{
            hoverCode:'applicationList',
            isLogin:true
          }
        },
        {
          path: '/fasterAuthCallBack',
          name: 'fasterAuthCallBack',             //应用授权
          component: resolve => require(['@/components/manager/fasterAuthCallBack'],resolve),
          meta:{
            hoverCode:'applicationList',
            isLogin:true
          }
        },
        {
          path: '/buildAplication',
          name: 'buildAplication',             //新建应用
          component: resolve => require(['@/components/manager/buildAplication'],resolve),
          meta:{
            hoverCode:'applicationList',
            isLogin:true
          }
        },
        {
          path: '/applicationDetails',
          name: 'applicationDetails',             //应用详情
          component: resolve => require(['@/components/manager/applicationDetails'],resolve),
          meta:{
            hoverCode:'applicationList',
            isLogin:true
          }
        },
        {
          path: '/personCenter',
          name: 'personCenter',             //账户中心
          component: resolve => require(['@/components/person/personCenter'],resolve),
          meta:{
            hoverCode:'personCenter',
            isLogin:true
          }
        },
        {
          path: '/documentCenter',
          name: 'documentCenter',             //文档中心
          component: resolve => require(['@/components/document/docList'],resolve),
          children:[
            {
              path: 'list',        //具体文档
              name: 'list',
              component: resolve => require(['@/components/document/documentList'],resolve),
            },
          ],
          meta:{
            hoverCode:'documentCenter',
          }
        },
      ]
    },
    {
      path: '/callback',
      name: 'callback',             //回调地址
      component: resolve => require(['@/components/authLogin/callback'],resolve),
    },

  ]
})

router.beforeEach((to, from, next) => {
  to.matched.map(item=>{
    console.log(to, from, next);
    localStorage['hoverCode'] = item.meta.hoverCode
    if(item.meta.isLogin){
      if(commonJs.getLocalstorage('accessToken','12')){
        next()
      }else{
        localStorage["toSaaSWhere"] = window.location.href;
        oidcJS.utils.login();
      }
    }else{
      next()
    }
  })
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js